<template>
    <div class="container">
        <h3 class="section_title">CONSULTA DE BOLETAS ELECTRÓNICAS </h3>
        
        <div class="row row-height mb-4">
            <div class="col-xl-7 col-lg-7 content-left">
                <div class="content-left-wrapper">
                    <div class="mr-3">
                        <img src="/img/boletas_digitales.jpg" width="100%" alt="Boletas Digitales DRASAM">
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-lg-5 content-right card borderTopCard shadow-sm">
                <form class="card-body">
                    <h3 class="main_question card-title" @click="play()">Datos del DNI</h3>
                    <div class="row row-height">  
                        <div class="form-group col-xl-6 col-lg-6">
                            <label>Número de DNI <span class="text-danger"> (*)</span></label>
                            <input type="text" placeholder="00000001" v-model="form.numero_documento_identidad" ref="numero_documento_identidad" class="form-control required" maxlength="8" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                            
                        </div>
                        <div class="form-group col-xl-6 col-lg-6">
                            <label for="">Dígito de verificación<span class="text-danger"> (*)</span></label>
                            <input type="text" placeholder="1" v-model="form.digito_verificacion" ref="digito_verificacion" class="form-control required text-right" maxlength="1" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Fecha de emisión<span class="text-danger"> (*)</span></label>
                        <input type="date" class="form-control required" v-model="form.fecha_emision" ref="fecha_emision">
                    </div>
                    
                    <div id="bottom-wizard">
                        <button :disabled="resultado.length>0" type="button" @click="consultarBoletas" class="btn btn-success btn-block">Validar</button>
                    </div>
                    <div class="form-group">
                        <div class="alert alert-warning" role="alert">
                            ¡Los campos que contengan <span class="text-danger"> (*)</span> son obligatorios!
                        </div>
                    </div>

                    <div v-if="errores!=''" class="form-group">
                        <div class="alert alert-danger" role="alert">
                            {{errores}}
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div v-if="resultado.length" class="row">
            <table class="table table-striped">
                <thead class="text-white" style="background: #0C605B">
                    <tr>
                        <th colspan="4" class="text-center">Hola <b style="color: black !important;">{{empleado_consulta}}</b>, tu consulta expira en {{ timerFormated }} Minutos</th>
                    </tr>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Periodo</th>
                        <th scope="col">Tipo Boleta</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(val, key) in resultado" :key="key" class="">
                        <th scope="row">{{key+1}}</th>
                        <td class="text-uppercase">{{val.anio}}-{{obtenerNombreMes(parseInt(val.mes))}}</td>
                        <td>{{val.boletas}}</td>
                        <td>
                            <button v-if="val.archivo_boletas" @click="downloadItem(base_url+'webserviceserver/fileCors?file='+val.archivo_boletas+'&dir=download_boletas_pago', val.archivo_boletas)" :title="val.archivo_boletas" :alt="'Descargar Boleta de pago del '+obtenerNombreMes(parseInt(val.mes))+', del '+val.anio" :class="['btn', 'btn-success']">
                                <i class="fa fa-download ml-2" aria-hidden="true"></i>
                                Descargar
                            </button>
                            <span v-else class="text-danger">
                                <i class="fa fa-file-pdf-o mr-2" aria-hidden="true"></i>Archivo no disponible :(
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'BoletasElectronicas',
        computed:{
            ...mapState(['loading','globales','empresa']),
            timerFormated(){
                return `${('0'+parseInt(this.countDown/60, 10)).slice(-2)}:${('0'+this.countDown % 60).slice(-2)}`;
            }
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Consulta de boleta electronica ||"+(this.empresa.abreviatura);
        },
        data(){
            return{
                form:{
                    numero_documento_identidad:""
                    ,digito_verificacion:""
                    ,fecha_emision:""
                },
                resultado:[],
                empleado_consulta:"",
                errores:"",
                base_url: `${window.baseUrl}`,
                countDown : 130,
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            consultarBoletas(){
                let selfs = this;
                if(!this.form.numero_documento_identidad){
                    this.$refs.numero_documento_identidad.focus();
					return;
                }else if(this.form.numero_documento_identidad.length<8){
                    this.$refs.numero_documento_identidad.focus();
					return;
                }

                if(!this.form.digito_verificacion){
                    this.$refs.digito_verificacion.focus();
					return;
                }

                if(!this.form.fecha_emision){
                    this.$refs.fecha_emision.focus();
					return;
                }
                let parametros = "nro_dni="+this.form.numero_documento_identidad;
                parametros+= "&digito_verificacion="+this.form.digito_verificacion;
                parametros+= "&fecha_emision="+this.form.fecha_emision;

                selfs.setLoading(true);
                selfs.$http.get('webserviceserver/consultar_boleta?'+parametros).then((res)=>{
                    if(!res.data.success){
                        selfs.resultado  = res.data.boletas_pago;
                        selfs.errores    = res.data.message;
                        return;
                    }

                    selfs.errores            = "";
                    selfs.resultado          = res.data.boletas_pago;
                    selfs.empleado_consulta  = res.data.empleado;
                    selfs.countDownTimer();
                })
                .catch(function (error) {
                    if(error.response){
                        //console.log(error.response.data);
                        //console.log(error.response.status);
                        //console.log(error.response.headers);
                        selfs.errores = error.response.data.message;
                    }else if (error.request) {
                        // La petición fue hecha pero no se recibió respuesta
                        // `error.request` es una instancia de XMLHttpRequest en el navegador y una instancia de
                        // http.ClientRequest en node.js
                        console.log(error.request);
                    }else {
                        // Algo paso al preparar la petición que lanzo un Error
                        console.log('Error', error.message);
                    }
                })
                .finally(()=>{
                    selfs.setLoading(false);
                });
            },
            countDownTimer() {
                if(this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000);
                }else{
                    this.alertWarning("Expiró el tiempo de espera de la consulta, gracias por su preferencia :)", function(){
						location.reload();
					});
                }
                //console.log(this.countDown);
            }
        },
    }
</script>